import { Link } from "react-router-dom";
import ForBusinessVectorText from "../icons/ForBusinessVectorText";
import TadarabLogo from "../icons/TadarabLogo";
import ArrowRightIcon from "../icons/ArrowRightIcon";

const TadarabForBusinessLogo = () => (
  <div className="hero__logos">
    <ForBusinessVectorText className="hero__for-business-text" />
    <TadarabLogo className="hero__brand-logo" />
  </div>
);

const TadarabWorldMicroCopies = () => (
  <div className="hero__copies">
    <div>
      <p className="hero__heading">اكتشف عالم تدرب للأعمال</p>
    </div>
    <div className="hero__sub-copies">
      <p className="hero__sub-heading">
        طوّر مهارات فريقك بما يتناسب مع احتياجات عملك اليوم
      </p>
      <p className="hero__sub-copy--1">
        تدرب للأعمال - شريكك الاستراتيجي لتطوير الكفاءات
      </p>
      <p className="hero__sub-copy--2">درّب. طوّر. قُد.</p>
    </div>
  </div>
);

const RequestDemoButton = ({ onRequestDemoClick }) => (
  <button className="hero__cta-btn" onClick={onRequestDemoClick}>
    <p>اطلب عرض توضيحي</p>
    <div className="hero__cta-icon">
      <ArrowRightIcon color="#fff" />
    </div>
  </button>
);

const ComparePlansButton = ({ onComparePlansClick }) => (
  <button className="hero__cta-btn" onClick={onComparePlansClick}>
    <p>قارن الخطط</p>
    <div className="hero__cta-icon">
      <ArrowRightIcon color="#fff" />
    </div>
  </button>
);

export default function Hero({ onRequestDemoClick, onComparePlansClick }) {
  return (
    <div className="hero">
      <div className="hero__media">
        <img
          src="/images/tadarab-for-business-hero-background.jpg"
          alt="Tadarab For Business"
          className="hero__image"
        />
        <div className="hero__gradient-overlay" />
        <div className="hero__content">
          <TadarabForBusinessLogo />
          <TadarabWorldMicroCopies />
          <div className="hero__cta-buttons">
            <ComparePlansButton
              onComparePlansClick={() => {
                window.scrollTo({
                  top: document.querySelector("#business-plans").offsetTop,
                  behavior: "smooth",
                });
              }}
            />
            <RequestDemoButton onRequestDemoClick={onRequestDemoClick} />
          </div>
        </div>
      </div>
    </div>
  );
}
